export const version = '1.2.0';
export const buildTime = 'Thu May 21 2026 13:37:38 GMT+0200 (Central European Summer Time)';
export const sourceUrl = 'https://github.com/CentreForDigitalHumanities/gen-ai-reflection/tree/0a2f35c4a6a64274b4acd6586d791cf75761fb25';
